import { useState, useEffect } from 'react';
import Modal from '../Modal/Modal.jsx';
import api from '../../services/api.js';
import './RecordForm.css';

/** Formulario metadata-driven: cria/edita um registo de qualquer objeto */
const RecordForm = ({ objectId, fields, record, onSaved, onClose }) => {
  const isEdit = !!record;
  const parseData = () => {
    if (!record) return {};
    try { return typeof record.data === 'string' ? JSON.parse(record.data) : (record.data || {}); } catch (_) { return {}; }
  };
  const [values, setValues] = useState(() => {
    const d = parseData();
    const v = {};
    fields.forEach((f) => { v[f.name] = isEdit ? (f.is_primary_label ? record.name : d[f.name] ?? '') : (f.default_value || ''); });
    return v;
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const set = (name, val) => setValues((s) => ({ ...s, [name]: val }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true); setError(null);
    try {
      const primary = fields.find((f) => f.is_primary_label);
      const name = primary ? values[primary.name] : '(sem nome)';
      const data = {};
      fields.forEach((f) => { if (!f.is_primary_label) data[f.name] = values[f.name] ?? ''; });
      const amountField = fields.find((f) => f.field_type === 'currency');
      const payload = { name, data, amount: amountField ? Number(values[amountField.name] || 0) || null : null, stage_id: isEdit ? (record.stage_id || null) : null };
      if (isEdit) {
        await api.put(`/byid/${record.id}`, payload);
      } else {
        await api.post(`/${objectId}/records`, payload);
      }
      onSaved();
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setSaving(false);
    }
  };

  const renderInput = (f) => {
    const v = values[f.name] ?? '';
    const common = { id: f.name, value: v, onChange: (e) => set(f.name, e.target.value), required: f.is_required };
    switch (f.field_type) {
      case 'longtext':
        return <textarea {...common} rows={3} className="gencrm_field_input" />;
      case 'number': case 'percent': case 'currency':
        return <input type="number" step="any" {...common} className="gencrm_field_input" />;
      case 'boolean':
        return <input type="checkbox" checked={!!v} onChange={(e) => set(f.name, e.target.checked)} />;
      case 'date':
        return <input type="date" {...common} className="gencrm_field_input" />;
      case 'datetime':
        return <input type="datetime-local" {...common} className="gencrm_field_input" />;
      case 'select': {
        let opts = []; try { opts = JSON.parse(f.options_json || '[]'); } catch (_) {}
        return (
          <select {...common} className="gencrm_field_input">
            <option value="">—</option>
            {opts.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        );
      }
      default:
        return <input type={f.field_type === 'email' ? 'email' : f.field_type === 'url' ? 'url' : 'text'} {...common} className="gencrm_field_input" />;
    }
  };

  return (
    <Modal title={isEdit ? 'Editar registo' : 'Novo registo'} onClose={onClose}>
      <form className="gencrm_form" onSubmit={submit}>
        {fields.map((f) => (
          <div className="gencrm_form__row" key={f.id}>
            <label htmlFor={f.name} className="gencrm_form__label">{f.label}{f.is_required ? ' *' : ''}</label>
            {renderInput(f)}
          </div>
        ))}
        {error && <div className="gencrm_form__error">{error}</div>}
        <div className="gencrm_form__actions">
          <button type="button" className="gencrm_btn gencrm_btn--secondary" onClick={onClose}>Cancelar</button>
          <button type="submit" className="gencrm_btn" disabled={saving}>{saving ? 'A guardar...' : (isEdit ? 'Guardar' : 'Criar')}</button>
        </div>
      </form>
    </Modal>
  );
};

export default RecordForm;
